require('./assets/index.scss')


// WEBPACK FOOTER //
// ./src/style.js